import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { attachAdServerContexts, useAdServer } from '@/features/ad-server/composables/useAdServer';
import { AdServerCreativeType } from '@/features/ad-server/types';

import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import type { UsePromotion } from '@/helpers/composables/usePromotion';
import { OfferLocation } from '@/helpers/offer-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdServerGridPromotionPlacement',
  props: {
    title: null,
    offers: null,
    inline: { type: Boolean },
    additionalContexts: null,
    showPromotionRow: { type: Boolean }
  },
  emits: ["clickOut"],
  setup(__props: any) {

const props = __props as {
	title: TitleDetail;
	offers: TitleOfferFragment[];
	inline?: boolean;
	additionalContexts: SnowplowContext[];
	showPromotionRow: boolean;
};

const GridPromotionRow = () => import('@/features/buybox/components/grid/GridPromotionRow.vue');
const GridSQTV = () => import('@/features/buybox/components/grid/GridSQTV.vue');
const GridRowLabel = () => import('@/features/buybox/components/grid/GridRowLabel.vue');





const { adServerCreative, adServerStatus } = useAdServer(() => props.title.id);

const adServerCreativeType = computed(() => adServerCreative.value?.__typename ?? null);

return { __sfc: true,GridPromotionRow, GridSQTV, GridRowLabel, props, adServerCreative, adServerStatus, adServerCreativeType, attachAdServerContexts, AdServerCreativeType }
}

})